/* === OMC Free Shipping Progress Bar (market-aware) === */
(function () {
  'use strict';
  var THRESHOLDS = { GBP: 7500, USD: 12000, EUR: 10500, CAD: 16500, AUD: 17500 };
  var SYMBOLS = { GBP: '£', USD: '$', EUR: '€', CAD: '$', AUD: '$' };
  var BAR_CLASS = 'omc-ship-bar';
  var CURR = 'GBP';
  function TH() { return THRESHOLDS[CURR] || THRESHOLDS.GBP; }
  function fmt(cents) {
    var suffix = CURR === 'CAD' || CURR === 'AUD' ? ' ' + CURR : '';
    return (SYMBOLS[CURR] || CURR + ' ') + (cents / 100).toFixed(2) + suffix;
  }
  function label() { return CURR === 'GBP' ? 'FREE UK SHIPPING' : 'FREE SHIPPING'; }
  function barHtml(total) {
    var pct = Math.min(100, Math.round((total / TH()) * 100));
    var msg = total >= TH()
      ? label() + ' UNLOCKED. AN ORDINARY TRIUMPH.'
      : fmt(TH() - total) + ' AWAY FROM ' + label();
    return '<div class="omc-ship-bar__text">' + msg + '</div>' +
      '<div class="omc-ship-bar__track"><div class="omc-ship-bar__fill' +
      (total >= TH() ? ' is-full' : '') + '" style="width:' + pct + '%"></div></div>';
  }
  function ensureBar(container, total) {
    if (!container) return;
    var bar = container.querySelector('.' + BAR_CLASS);
    if (total <= 0) { if (bar) bar.remove(); return; }
    if (!bar) {
      bar = document.createElement('div');
      bar.className = BAR_CLASS;
      container.insertBefore(bar, container.firstChild);
    }
    var html = barHtml(total);
    if (bar.innerHTML !== html) bar.innerHTML = html;
  }
  function targets() {
    var list = [];
    var drawer = document.querySelector('.cart-drawer__dialog');
    if (drawer) {
      var inner = drawer.querySelector('.cart-drawer__inner, .cart-drawer__content, form, .cart-items') || drawer;
      list.push(inner);
    }
    if (location.pathname.replace(/\/$/, '') === '/cart') {
      var main = document.querySelector('main .cart-page, main form[action="/cart"], main');
      if (main) list.push(main);
    }
    return list;
  }
  var lastTotal = null;
  function refresh() {
    fetch('/cart.js', { headers: { accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        CURR = cart.currency || 'GBP';
        lastTotal = cart.total_price;
        targets().forEach(function (t) { ensureBar(t, cart.total_price); });
      })
      .catch(function () {});
  }
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = origFetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(refresh, 250); });
    }
    return p;
  };
  var mo = new MutationObserver(function () {
    if (lastTotal !== null) targets().forEach(function (t) { ensureBar(t, lastTotal); });
  });
  function init() {
    refresh();
    var drawer = document.querySelector('.cart-drawer__dialog');
    if (drawer) mo.observe(drawer, { childList: true, subtree: true });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[href="/cart"], .cart-drawer__trigger, [aria-controls*="cart"], .header-actions__cart-icon')) {
        setTimeout(refresh, 300);
      }
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
(function () {
  'use strict';
  var TEXT = 'SECURE CHECKOUT · VISA · MASTERCARD · PAYPAL · SHOP PAY · G PAY';
  function inject() {
    document.querySelectorAll('button[name="checkout"], button#checkout, a[href="/checkout"]').forEach(function (btn) {
      var host = btn.closest('div, form') || btn.parentElement;
      if (host && !host.querySelector('.omc-trust-line')) {
        var el = document.createElement('div');
        el.className = 'omc-trust-line';
        el.textContent = TEXT;
        btn.insertAdjacentElement('afterend', el);
      }
    });
  }
  inject();
  new MutationObserver(inject).observe(document.body, { childList: true, subtree: true });
})();


/* Rivo launcher relabel: 'Rewards' -> 'Refer & Earn' (brand voice) */
(function () {
  'use strict';
  function relabel() {
    var w = document.querySelector('#launcher-wrapper');
    if (!w) return;
    var nodes = w.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.children.length === 0 && /rewards/i.test(n.textContent || '') && n.textContent.trim() !== 'Refer & Earn') {
        n.textContent = 'Refer & Earn';
      }
    }
  }
  new MutationObserver(relabel).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', relabel);
  else relabel();
})();


/* ===== Dynamic header offset: keep header below announcement bar of any height ===== */
(function(){
  function omcHdrOff(){
    var a=document.querySelector('.omc-announcement');
    var wr=document.getElementById('omc-header-wrap');
    if(!a||!wr)return;
    var s=document.documentElement.style;
    s.setProperty('--omc-ann-h',a.offsetHeight+'px');
    s.setProperty('--omc-page-top',(a.offsetHeight+wr.offsetHeight)+'px');
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',omcHdrOff);}else{omcHdrOff();}
  window.addEventListener('load',omcHdrOff);
  window.addEventListener('resize',omcHdrOff);
  if(window.ResizeObserver){
    var t=setInterval(function(){var a=document.querySelector('.omc-announcement');if(a){clearInterval(t);new ResizeObserver(omcHdrOff).observe(a);}},500);
    setTimeout(function(){clearInterval(t);},10000);
  }
})();


/* ===== omcWidgetDelegate: open Rivo widget from page CTAs (cache-proof) ===== */
(function(){
  if (window.__omcOpenBound) return; window.__omcOpenBound = true;
  document.addEventListener('click', function(e){
    var t = e.target.closest ? e.target.closest('#omc-loyalty-open, #omc-referral-open, .omc-referral__open') : null;
    if (!t) return;
    e.preventDefault();
    var w = document.getElementById('launcher-wrapper');
    if (w) { var h = w.querySelector('.ba-met-handler'); (h || w).click(); }
    else { window.location.href = '/account'; }
  }, true);
})();





/* ===== omcFooterDock: floating pills stop above the footer, follow on scroll up ===== */
(function(){
  var baseL = 96;
  var selBase = null;
  function footerEl(){
    var best = null, top = null;
    document.querySelectorAll('footer, [id*="__footer"]').forEach(function(e){
      var t = e.getBoundingClientRect().top;
      if (e.offsetHeight > 40 && (top === null || t < top)) { top = t; best = e; }
    });
    return best;
  }
  function tick(){
    var f = footerEl(); if (!f) return;
    var overlap = Math.max(0, window.innerHeight - f.getBoundingClientRect().top);
    var w = document.getElementById('launcher-wrapper');
    if (w && !w.classList.contains('omc-dodge')) {
      if (overlap > 0) { w.style.setProperty('--omc-dock', (baseL + overlap) + 'px'); w.classList.add('omc-dock'); }
      else { w.classList.remove('omc-dock'); }
    }
    
  }
  var ticking = false;
  function onScroll(){ if (!ticking) { ticking = true; requestAnimationFrame(function(){ tick(); ticking = false; }); } }
  window.addEventListener('scroll', onScroll, {passive: true});
  window.addEventListener('resize', onScroll);
  setTimeout(tick, 1500);
})();

/* ===== omcTopSwitch: country selector lives in the top announcement banner ===== */
(function(){
  var CSS = [
    '.sel-disclosure-btn { background: rgba(255,255,255,0.08) !important; border: 1px solid #4a4a4a !important; border-radius: 3px !important; box-shadow: none !important; padding: 3px 9px 3px 7px !important; min-height: 0 !important; }',
    '.sel-disclosure-btn:hover { border-color: #ffffff !important; }',
    '.sel-disclosure-btn .sel-title { color: #ffffff !important; max-width: none !important; overflow: visible !important; text-overflow: clip !important; white-space: nowrap !important; font-size: 12px !important; font-family: Courier New, Courier, monospace !important; font-weight: 700 !important; letter-spacing: 0.03em !important; }',
    '.sel-iconWrapper { width: 17px !important; height: 17px !important; }',
    '.sel-icon { width: 17px !important; height: 17px !important; }',
    '.sel-pointerContainer, .sel-pointerContainer svg, .sel-pointerContainer path { color: #ffffff !important; fill: #ffffff !important; stroke: #ffffff !important; }',
    '.sel-itemsContainer { top: calc(100% + 8px) !important; bottom: auto !important; right: 0 !important; left: auto !important; z-index: 10003 !important; }',
    '.sel-disclosure-btn[aria-expanded="true"] ~ .sel-itemsContainer { max-height: min(65vh, 430px) !important; overflow: auto !important; }',
    '.sel-item .sel-title { color: #111111 !important; }',
    '@media (max-width: 749px) { .sel-disclosure-btn .sel-title { display: none !important; } .sel-disclosure-btn { padding: 4px 6px !important; } }' , '.sel-itemsContainer { min-width: 250px; }'
  ].join(String.fromCharCode(10));
  function apply(){
    var sr = document.querySelector("selector-root");
    if (!sr || !sr.shadowRoot) return false;
    sr.classList.add("omc-top-switch");
    var acts = document.querySelector(".omc-header__actions");
    if (acts && sr.parentElement !== acts) { acts.insertBefore(sr, acts.firstElementChild); }
    sr.style.removeProperty("bottom");
    if (!sr.shadowRoot.getElementById("omc-topswitch-style")) {
      var st = document.createElement("style");
      st.id = "omc-topswitch-style";
      st.textContent = CSS;
      sr.shadowRoot.appendChild(st);
    }
    return true;
  }
  var tries = 0;
  var t = setInterval(function(){
    tries++;
    if (apply() && tries > 5) clearInterval(t);
    if (tries > 40) clearInterval(t);
  }, 800);
  function omcSeq(btn){
    window.__omcSwBusy = true;
    ['pointerdown','mousedown','pointerup','mouseup','click'].forEach(function(tp){
      btn.dispatchEvent(new MouseEvent(tp, {bubbles: true, composed: true, cancelable: true}));
    });
    window.__omcSwBusy = false;
  }
  document.addEventListener('click', function(ev){
    if (window.__omcSwBusy) return;
    var sr = document.querySelector('selector-root');
    if (!sr || !sr.shadowRoot) return;
    var btn = sr.shadowRoot.querySelector('.sel-disclosure-btn');
    if (!btn) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    var path = ev.composedPath ? ev.composedPath() : [];
    var inner = path[0];
    var inBtn = inner && inner.closest && inner.closest('.sel-disclosure-btn');
    var inItem = inner && inner.closest && inner.closest('.sel-item');
    if (inBtn) {
      ev.stopImmediatePropagation();
      ev.preventDefault();
      omcSeq(btn);
    } else if (open && !inItem && !(ev.target === sr || sr.contains(ev.target))) {
      omcSeq(btn);
    }
  }, true);
})();

/* ===== omcPdpCounter: Represent-style 1/N photo counter on PDPs ===== */
(function(){
  function initGallery(gal){
    if (gal.__omcCnt) return;
    var sc = gal.querySelector("slideshow-container");
    var dotsWrap = gal.querySelector(".slideshow-controls__dots");
    if (!sc || !dotsWrap) return;
    var dots = dotsWrap.querySelectorAll("button");
    if (dots.length < 2) return;
    gal.__omcCnt = true;
    var counter = document.createElement("div");
    counter.className = "omc-pdp-counter";
    if (getComputedStyle(sc).position === "static") sc.style.position = "relative";
    sc.appendChild(counter);
    function update(){
      var d = dotsWrap.querySelectorAll("button");
      var total = d.length, cur = 1;
      for (var i=0;i<d.length;i++){ if (d[i].getAttribute("aria-selected")==="true"){ cur = i+1; break; } }
      counter.textContent = cur + " / " + total;
    }
    update();
    try { new MutationObserver(update).observe(dotsWrap, {subtree:true, attributes:true, attributeFilter:["aria-selected"]}); } catch(e){}
  }
  function scan(){ document.querySelectorAll("media-gallery").forEach(initGallery); }
  scan();
  var n=0, t=setInterval(function(){ scan(); if(++n>12) clearInterval(t); }, 700);
  document.addEventListener("shopify:section:load", scan);
})();

/* ===== PDP customer review injection (social proof) ===== */
(function(){
  var HTML = "<div class=\"omc-review\"><div class=\"omc-review__label\">CLUB INTEL // UNSOLICITED — EXHIBIT B</div><div class=\"omc-review__bubble\"><p>Gear arrived today. Awesome quality.</p><p>Got beat by 3 mins by my 10-year-old in a 6k race today — so this’ll definitely help close the gap 😂</p></div><div class=\"omc-review__foot\"><span class=\"omc-review__avatar\" aria-hidden=\"true\"></span><span class=\"omc-review__meta\"><span class=\"omc-review__stars\">★★★★★</span><span class=\"omc-review__attr\">Real member · slid into the DMs · via Instagram</span></span></div></div>";
  function inject(){
    try{
      var atc = document.querySelector('add-to-cart-component');
      if(!atc) return;
      if(document.querySelector('.omc-review')) return;
      var scope = atc.closest('.product-details') || atc.closest('[class*=product-details]');
      if(!scope) return;
      var anchor = scope.querySelector('variant-picker') || scope.querySelector('.buy-buttons-block') || scope.querySelector('[class*=buy-buttons]');
      if(!anchor) anchor = atc.closest('.buy-buttons-block') || atc;
      if(!anchor || !anchor.parentElement) return;
      var wrap = document.createElement('div');
      wrap.innerHTML = HTML;
      anchor.parentElement.insertBefore(wrap.firstElementChild, anchor);
    }catch(e){}
  }
  if(document.readyState!=='loading') inject(); else document.addEventListener('DOMContentLoaded', inject);
  document.addEventListener('shopify:section:load', inject);
  setTimeout(inject, 500); setTimeout(inject, 1400);
})();

/* ===== Add-to-cart feedback: live count + toast + icon bump ===== */
(function(){
  document.addEventListener('click', function(e){
    var btn = e.target.closest('add-to-cart-component button, [name=add], .add-to-cart-button');
    if(!btn) return;
    window.__omcAddAt = Date.now();
    var scope = btn.closest('.product-details, .product-information') || btn.closest('[class*=product-card], product-card, li');
    var t = scope && scope.querySelector('.view-product-title, h1, h2, .product-title, [class*=product-title]');
    var nm = t ? t.textContent.trim() : '';
    if(!nm){ var og = document.querySelector('meta[property="og:title"]'); if(og){ nm = og.content.split(/[\u2013\u2014|]/)[0].trim(); } }
    window.__omcLastAdded = nm;
  }, true);
  function setCount(n){
    var link = document.querySelector('.omc-header__cart-link');
    var badge = document.querySelector('.omc-header__cart-count');
    if(n > 0){
      if(!badge && link){ badge = document.createElement('span'); badge.className = 'omc-header__cart-count'; link.appendChild(badge); }
      if(badge){ badge.textContent = n; badge.style.removeProperty('display'); }
    } else if(badge){ badge.style.display = 'none'; }
  }
  function bump(){
    var link = document.querySelector('.omc-header__cart-link');
    if(link){ link.classList.remove('omc-bump'); void link.offsetWidth; link.classList.add('omc-bump'); }
  }
  var toastEl, hideTimer;
  function ensureToast(){
    if(toastEl && document.body.contains(toastEl)) return toastEl;
    toastEl = document.createElement('div');
    toastEl.className = 'omc-cart-toast';
    toastEl.innerHTML = '<div class="omc-cart-toast__title">Added to cart \u2713</div><div class="omc-cart-toast__name"></div><a class="omc-cart-toast__link" href="/cart">View cart \u2192</a>';
    document.body.appendChild(toastEl);
    return toastEl;
  }
  function showToast(){
    if(location.pathname === '/cart') return;
    if(!window.__omcAddAt || (Date.now() - window.__omcAddAt) > 6000) return;
    var el = ensureToast();
    var nm = window.__omcLastAdded || '';
    var nmEl = el.querySelector('.omc-cart-toast__name');
    nmEl.textContent = nm; nmEl.style.display = nm ? '' : 'none';
    void el.offsetWidth; el.classList.add('is-visible');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function(){ el.classList.remove('is-visible'); }, 3200);
  }
  function refresh(){
    fetch('/cart.js', {headers:{'accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){ setCount(c.item_count); bump(); showToast(); }).catch(function(){});
  }
  document.addEventListener('cart:update', refresh);
  document.addEventListener('cart:refresh', refresh);
  document.addEventListener('cart:change', refresh);
})();

/* ===== Mobile floating add-to-cart button (adds for no-variant, scrolls to picker otherwise) ===== */
(function(){
  function isMobile(){ return window.matchMedia('(max-width: 749px)').matches; }
  function stickyTop(){
    var b = 0;
    document.querySelectorAll('header, .omc-header, [class*=header], [class*=announcement]').forEach(function(e){
      var cs = getComputedStyle(e);
      if(cs.position === 'fixed' || cs.position === 'sticky'){ var r = e.getBoundingClientRect(); if(r.top <= 2 && r.height > 0 && r.height < 300 && r.bottom > b){ b = r.bottom; } }
    });
    return b || 140;
  }
  function build(){
    if(!isMobile()) return;
    var media = document.querySelector('.product-information__media');
    var atc = document.querySelector('add-to-cart-component');
    if(!media || !atc) return;
    if(media.querySelector('.omc-mobile-cta')) return;
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'omc-mobile-cta'; btn.textContent = 'Add to cart'; btn.setAttribute('aria-label','Add to cart');
    media.appendChild(btn);
    btn.addEventListener('click', function(){
      var picker = document.querySelector('.product-details variant-picker') || document.querySelector('variant-picker');
      if(picker){
        var off = stickyTop() + 18;
        var y = picker.getBoundingClientRect().top + window.pageYOffset - off;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
        picker.classList.remove('omc-flash'); void picker.offsetWidth; picker.classList.add('omc-flash');
      } else {
        var real = atc.querySelector('button');
        if(real) real.click();
      }
    });
  }
  function run(){ try{ build(); }catch(e){} }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  window.addEventListener('resize', run);
  setTimeout(run, 700); setTimeout(run, 1600);
})();

/* ===== ATC conversion levers: sticky bar + size guide + just-dropped ===== */
(function(){
  function isMobile(){ return window.matchMedia('(max-width: 749px)').matches; }
  function openSpecs(){
    var nodes=[].slice.call(document.querySelectorAll('summary, button, [role=button], [class*=accordion]'));
    var t=nodes.filter(function(e){return /SIZE\s*\+\s*SPECS/i.test((e.textContent||'').slice(0,40));})[0];
    if(!t){ t=[].slice.call(document.querySelectorAll('*')).filter(function(e){return e.children.length<3 && /^\s*SIZE\s*\+\s*SPECS\s*$/i.test((e.textContent||''));})[0]; }
    if(t){ try{t.click();}catch(e){} try{t.scrollIntoView({behavior:'smooth',block:'center'});}catch(e){} }
  }
  function build(){
   try{
    var atc=document.querySelector('add-to-cart-component'); if(!atc) return;
    var scope=atc.closest('.product-details'); if(!scope) return;
    /* Just-dropped badge */
    if(!scope.querySelector('.omc-drop-badge')){
      var titleWrap=scope.querySelector('.view-product-title');
      if(titleWrap && titleWrap.parentElement){ var b=document.createElement('div'); b.className='omc-drop-badge'; b.textContent='\u25CF Just dropped'; titleWrap.parentElement.insertBefore(b, titleWrap); }
    }
    /* Size-confidence prompt (only if variants) */
    var vp=scope.querySelector('variant-picker');
    if(vp && !scope.querySelector('.omc-sizeconf')){
      var sc=document.createElement('div'); sc.className='omc-sizeconf';
      sc.innerHTML='<span class="omc-sizeconf__tick">\u2713 True to size</span><button type="button" class="omc-sizeconf__link">Not sure? View size guide</button>';
      vp.parentElement.insertBefore(sc, vp.nextSibling);
      sc.querySelector('.omc-sizeconf__link').addEventListener('click', openSpecs);
    }
    /* Sticky mobile ATC bar */
    if(isMobile() && !document.querySelector('.omc-sticky-atc')){
      var titleEl=scope.querySelector('.view-product-title');
      var priceEl=scope.querySelector('.price');
      var bar=document.createElement('div'); bar.className='omc-sticky-atc';
      var info=document.createElement('div'); info.className='omc-sticky-atc__info';
      var t1=document.createElement('span'); t1.className='omc-sticky-atc__title'; t1.textContent=(titleEl?titleEl.textContent.trim():document.title.split('\u2013')[0].trim());
      var t2=document.createElement('span'); t2.className='omc-sticky-atc__price'; t2.textContent=(priceEl?priceEl.textContent.trim():'');
      info.appendChild(t1); info.appendChild(t2);
      var btn=document.createElement('button'); btn.type='button'; btn.className='omc-sticky-atc__btn'; btn.textContent='Add to cart';
      btn.addEventListener('click', function(){ var real=atc.querySelector('button'); if(real) real.click(); });
      bar.appendChild(info); bar.appendChild(btn); document.body.appendChild(bar);
      if('IntersectionObserver' in window){ var io=new IntersectionObserver(function(en){ en.forEach(function(e){ bar.classList.toggle('is-visible', !e.isIntersecting); }); },{threshold:0}); io.observe(atc); }
      else { window.addEventListener('scroll', function(){ var r=atc.getBoundingClientRect(); bar.classList.toggle('is-visible', r.bottom<0 || r.top>window.innerHeight); }); }
    }
   }catch(e){}
  }
  function run(){ build(); }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  window.addEventListener('resize', run);
  setTimeout(run,700); setTimeout(run,1600);
})();


/* OMC mobile PDP review rating pill */
(function(){
  function initOmcMobileRating(){
    try{
      if(!/\/products\//.test(location.pathname)) return;
      if(document.querySelector('.omc-mobile-rating')) return;
      var badge=document.querySelector('.jdgm-prev-badge');
      var media=document.querySelector('.product-information__media');
      if(!badge||!media) return;
      var num=parseInt(badge.getAttribute('data-number-of-reviews')||'0',10);
      var avg=parseFloat(badge.getAttribute('data-average-rating')||'0');
      if(!num) return;
      var full=Math.round(avg), stars='';
      for(var i=0;i<5;i++){ stars+= (i<full)?'★':'☆'; }
      var el=document.createElement('a');
      el.className='omc-mobile-rating'; el.href='#judgeme_product_reviews';
      el.setAttribute('aria-label', num+' reviews');
      el.innerHTML='<span class="omc-mr-stars">'+stars+'</span><span class="omc-mr-count">'+num+' review'+(num===1?'':'s')+'</span>';
      el.addEventListener('click', function(e){ e.preventDefault(); var t=document.querySelector('#judgeme_product_reviews')||document.querySelector('.jm-review-widget')||document.querySelector('.jdgm-widget'); if(t){ t.scrollIntoView({behavior:'smooth', block:'start'}); } });
      media.insertBefore(el, media.firstChild);
    }catch(e){}
  }
  var _t=0, _iv=setInterval(function(){ _t++; initOmcMobileRating(); if(document.querySelector('.omc-mobile-rating')||_t>25){ clearInterval(_iv); } }, 600);
  document.addEventListener('DOMContentLoaded', function(){ setTimeout(initOmcMobileRating, 500); });
})();


/* OMC: mobile photo ATC (.omc-sticky-atc) scrolls to the size picker at a correct offset (fixes overshoot) */
(function(){
  function isMobile(){ return window.matchMedia('(max-width:749px)').matches; }
  function stickyOffset(){
    var max=0;
    document.querySelectorAll('.omc-header, header, sticky-header, [class*="announcement"]').forEach(function(el){
      try{ var c=getComputedStyle(el); var r=el.getBoundingClientRect();
        if((c.position==='fixed'||c.position==='sticky') && r.top<=1 && r.height>8 && r.bottom>max){ max=r.bottom; }
      }catch(_){ }
    });
    return max>0?max:110;
  }
  document.addEventListener('click', function(e){
    try{
      if(!isMobile()) return;
      var btn=e.target.closest('.omc-sticky-atc');
      if(!btn) return;
      var vp=document.querySelector('variant-picker');
      if(!vp) return;
      e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation) e.stopImmediatePropagation();
      var y=window.scrollY + vp.getBoundingClientRect().top - stickyOffset() - 30;
      window.scrollTo({ top: Math.max(0,y), behavior:'smooth' });
    }catch(_){ }
  }, true);
})();
/* omc-jsbump-1784701180080 */
